module.exports = __webpack_public_path__ + "static/img/chengcaiyuncang.fde36cc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/chengcaiyuncang.jpg
// module id = iVwa
// module chunks = 52